<template>
  <span class="avatar">
    <a-avatar v-if="isPic" class="wh-avatar" :src="src" :size="size" />
    <!-- <div v-else class="wh-avatar text-avatar" :style="style">
      {{ src }}
    </div> -->
    <div v-else class="wh-avatar text-avatar" :style="style"></div>
  </span>
</template>
<script>
export default {
  name: 'Avatar',
  props: {
    src: {
      type: String,
      default: ''
    },
    bgColor: {
      type: String,
      default: '#9590CF'
    },
    size: {
      type: Number,
      default: 16
    }
  },
  computed: {
    style () {
      const { size } = this
      return {
        width: `${size}px`,
        height: `${size}px`,
        'line-height': `${size}px`,
        'font-size': `${size * 0.65}px`,
        // 'background': bgColor,
        'box-shadow': `0 ${size * 0.18}px ${size * 0.3}px -${size * 0.2}px rgba(0,0,0,0.5)`
      }
    },
    isPic () {
      return /.(png|jpeg|jpg|gif)$/.test(this.src)
    }
  }
}
</script>
<style lang="less" scoped>
  .wh-avatar {
    border-radius: 50%;
  }
  .text-avatar {
    display: inline-block;
    overflow: hidden;
    text-align: center;
    color: #fff;
    background: url('./avator.png') no-repeat 100% 100%;
    background-size: cover;
  }
  .avatar {
    display: flex;
    align-items: center;
  }
</style>
